import store from '@/store'
import moment from 'moment'

export const ListGuards = {
  onEnter (to, from, next) {
    let query = {
      with: 'dealer',
      ...to.query
    }
    store.dispatch('branches/query', query).then((response) => {
      next()
    }).catch(error => {
      next(error)
    })
  },
  onUpdate (to, from, next) {
    let query = {
      with: 'dealer',
      ...to.query
    }
    store.dispatch('branches/query', query).then((response) => {
      next()
    }).catch(error => {
      next(error)
    })
  }
}

export const ViewGuards = {
  onEnter (to, from, next) {
    let promises = []
    promises.push(store.dispatch('evaluations/query', {
      'filters[where][branchId][eq]': to.params.id,
      with: 'assignment, branch, layout, period',
      ...to.query
    }))
    promises.push(store.dispatch('periods/query', {sort: 'endDate desc', limit: 1000}).then(({data}) => {
      let currentPeriodId = null
      for (let period of data.items) {
        let today = moment()
        if (moment(period.startDate) <= today && moment(period.endDate) >= today) {
          store.dispatch('periods/current', period.id)
          currentPeriodId = period.id
        }
      }
      let periodPromises = []
      periodPromises.push(store.dispatch('branchScores/query', {
        'filters[where][periodId][eq]': currentPeriodId,
        'filters[where][branchId][eq]': to.params.id
      }))
      periodPromises.push(store.dispatch('branchDivisionScores/query', {
        'filters[where][periodId][eq]': currentPeriodId,
        'filters[where][branchId][eq]': to.params.id
      }))
      return Promise.all(periodPromises)
    }))
    promises.push(store.dispatch('branches/get', {id: to.params.id, with: 'dealer'}))
    Promise.all(promises).then(() => {
      next()
    }).catch(error => {
      next(error)
    })
  },
  onUpdate (to, from, next) {
    let promises = []
    promises.push(store.dispatch('evaluations/query', {
      'filters[where][branchId][eq]': to.params.id,
      with: 'assignment, branch',
      ...to.query
    }))
    promises.push(store.dispatch('branches/get', {id: to.params.id, with: 'dealer'}))
    Promise.all(promises).then(() => {
      next()
    }).catch(error => {
      next(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/guards/branches.guards.js